import _extends from "@babel/runtime/helpers/extends";

/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../internal'; // eslint-disable-next-line react/display-name

var IconComponent = React.forwardRef(function (props, ref) {
  return React.createElement("svg", _extends({}, props, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), React.createElement("g", {
    id: "16x16/baby",
    clipPath: "url(#clip_Baby)"
  }, React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0506 7.34929C12.9294 7.33666 13.8043 6.99507 14.4749 6.32452C15.8417 4.95769 15.8417 2.74161 14.4749 1.37478C13.108 0.00794105 10.892 0.00794096 9.52513 1.37478C8.71093 2.18897 8.38174 3.3045 8.53754 4.36237L7 5.8999L4 2.8999L2.375 4.5249L4.66589 6.81579C3.60334 6.89276 2.56244 7.33747 1.75001 8.14989C-0.0449117 9.94481 -0.0449122 12.855 1.75001 14.6499C3.54493 16.4448 6.45507 16.4448 8.24999 14.6499C9.06242 13.8374 9.50712 12.7965 9.5841 11.734L12.125 14.2749L13.75 12.6499L10.25 9.14989L12.0506 7.34929ZM6.83578 13.2357C5.82191 14.2495 4.17809 14.2495 3.16422 13.2357C2.15035 12.2218 2.15035 10.578 3.16422 9.56411C4.17809 8.55024 5.82191 8.55024 6.83578 9.56411C7.84965 10.578 7.84965 12.2218 6.83578 13.2357Z",
    fill: "currentColor"
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "clip0"
  }, React.createElement("rect", {
    width: "16",
    height: "16",
    fill: "white"
  }))));
});
/**
 * Компоненты иконки <br />
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.<br />
 * Подключение иконки: `import { Baby16 } from '@cian/ui-kit/icons';`, <br />
 * где 16 - это размер иконки в пикселях.
 */

export var Baby16 = createIcon(IconComponent);